function teamDropdown() {
  const dropdown = document.querySelector(".jump-nav .dropdown");
  if (!dropdown) return;
  
  const toggle = dropdown.querySelector(".dropdown-toggle");
  const menu = dropdown.querySelector(".dropdown-menu");
  const items = menu?.querySelectorAll("a[role=menuitem]");
  
  if (!toggle || !menu || !items?.length) return;
  
  let currentIndex = -1;
  toggle.addEventListener("click", function () {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    menu.classList.toggle("dropdown-menu--active");
    dropdown.setAttribute("aria-expanded", !isOpen);

    toggle.setAttribute("aria-expanded", !isOpen);
    currentIndex = -1;
  });

  toggle.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
      e.preventDefault();
      toggle.setAttribute("aria-expanded", "true");
      menu.classList.add("dropdown-menu--active");

      items[0]?.focus();
      currentIndex = 0;
    }
  });

  items.forEach((item, index) => {
    item.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        currentIndex = (index + 1) % items.length;
        items[currentIndex].focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        currentIndex = index === 0 ? items.length - 1 : index - 1;
        items[currentIndex].focus();
      } else if (e.key === "Escape") {
        toggle.setAttribute("aria-expanded", "false");
        menu.classList.remove("dropdown-menu--active");

        toggle.focus();
        currentIndex = -1;
      }
    });

    item.addEventListener("click", function () {
      toggle.setAttribute("aria-expanded", "false");
      menu.classList.remove("dropdown-menu--active");

      currentIndex = -1;
    });
  });

  document.addEventListener("click", function (e) {
    if (!dropdown.contains(e.target)) {
      toggle.setAttribute("aria-expanded", "false");
      menu.classList.remove("dropdown-menu--active");
      currentIndex = -1;
    }
  });
}

export default function initTeamDropdown() {
  // Check if elements exist before initializing
  const dropdown = document.querySelector(".jump-nav .dropdown");
  if (!dropdown) return;
  
  teamDropdown();
}
